import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState("en");

  const setLang = (l) => {
    setLangState(l);
    document.documentElement.lang = l;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (field) => {
    if (field == null) return "";
    if (typeof field === "string") return field;
    return field[lang] ?? field.it ?? "";
  };

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const UI = {
  nav: {
    experience: { it: "Experience", en: "Experience" },
    services: { it: "Servizi", en: "Services" },
    vehicle: { it: "Viaggiare", en: "On board" },
    contacts: { it: "Contatti", en: "Contact" },
    cta: { it: "Prenota il tuo transfer", en: "Book your transfer" },
  },
  whatsapp: { it: "Scrivici su WhatsApp", en: "Message us on WhatsApp" },
  hero: {
    headline: {
      it: ["Il tuo private driver", "attorno alle Dolomiti"],
      en: ["Your private driver", "around the Dolomites"],
    },
  },
  footer: {
    legal: { it: "Termini e condizioni", en: "Terms & Conditions" },
    privacy: { it: "Privacy Policy", en: "Privacy Policy" },
    cookies: { it: "Cookie Policy", en: "Cookie Policy" },
    manage: { it: "Gestisci preferenze cookie", en: "Manage cookie preferences" },
    reserved: { it: "Area riservata", en: "Restricted area" },
    rights: { it: "Tutti i diritti riservati.", en: "All rights reserved." },
  },
  cookie: {
    title: { it: "Rispettiamo la tua privacy", en: "We respect your privacy" },
    text: {
      it: "Utilizziamo cookie tecnici per il funzionamento del sito e, previo consenso, cookie analitici di Google Analytics 4 per comprendere come i visitatori utilizzano il sito, in forma aggregata e anonima. Puoi accettare tutti i cookie, solo quelli necessari o personalizzare le tue preferenze.",
      en: "We use technical cookies for the website to work and, with your consent, Google Analytics 4 analytical cookies to understand how visitors use the site, in aggregate and anonymous form. You can accept all cookies, only the necessary ones, or customise your preferences.",
    },
    analytics: { it: "Cookie analitici (Google Analytics 4)", en: "Analytical cookies (Google Analytics 4)" },
    acceptAll: { it: "Accetta tutti", en: "Accept all" },
    necessary: { it: "Solo necessari", en: "Necessary only" },
    save: { it: "Salva preferenze", en: "Save preferences" },
    policy: { it: "Cookie Policy", en: "Cookie Policy" },
  },
  form: {
    name: { it: "Nome e cognome *", en: "Full name *" },
    namePh: { it: "Come possiamo chiamarti?", en: "How may we address you?" },
    email: { it: "Email *", en: "Email *" },
    emailPh: { it: "nome@email.it", en: "name@email.com" },
    phone: { it: "Telefono / WhatsApp *", en: "Phone / WhatsApp *" },
    phonePh: { it: "Prefisso internazionale incluso", en: "Include country code" },
    service: { it: "Servizio richiesto *", en: "Requested service *" },
    servicePh: { it: "Seleziona uno dei sei servizi", en: "Select one of the six services" },
    date: { it: "Data del servizio *", en: "Service date *" },
    time: { it: "Orario indicativo *", en: "Indicative time *" },
    departure: { it: "Luogo di partenza *", en: "Departure *" },
    departurePh: { it: "Hotel, indirizzo, aeroporto o stazione", en: "Hotel, address, airport or station" },
    destination: { it: "Destinazione *", en: "Destination *" },
    destinationPh: { it: "Località o indirizzo", en: "Location or address" },
    trip: { it: "Tipo di viaggio *", en: "Trip type *" },
    tripOne: { it: "Solo andata", en: "One way" },
    tripReturn: { it: "Andata e ritorno", en: "Return trip" },
    passengers: { it: "Numero di passeggeri *", en: "Number of passengers *" },
    passengersPh: { it: "Adulti e bambini", en: "Adults and children" },
    luggage: { it: "Bagagli", en: "Luggage" },
    luggagePh: { it: "Numero di valigie e bagagli a mano", en: "Number of suitcases and hand luggage" },
    flight: { it: "Volo o treno", en: "Flight or train" },
    flightPh: { it: "Numero e orario previsto", en: "Number and scheduled time" },
    children: { it: "Bambini", en: "Children" },
    childrenPh: { it: "Età e altezza; indica se serve un sistema di ritenuta", en: "Age and height; indicate if a child restraint is needed" },
    pets: { it: "Animali", en: "Pets" },
    equipment: { it: "Attrezzatura speciale", en: "Special equipment" },
    equipmentPh: { it: "Sci, passeggini o colli fuori misura", en: "Skis, strollers or oversized items" },
    message: { it: "Messaggio", en: "Message" },
    messagePh: { it: "Aggiungi tappe, esigenze e informazioni utili", en: "Add stops, needs and useful information" },
    submit: { it: "Invia la richiesta", en: "Send the request" },
    sending: { it: "Invio in corso…", en: "Sending…" },
    required: { it: "Campo obbligatorio", en: "Required field" },
    invalidEmail: { it: "Email non valida", en: "Invalid email" },
    selectService: { it: "Seleziona un servizio", en: "Please select a service" },
    privacyRequired: { it: "È necessario accettare l'informativa privacy", en: "You must accept the privacy policy" },
    sent: { it: "Richiesta inviata", en: "Request sent" },
  },
  services_types: {
    airport: { it: "Airport & Railway Transfers", en: "Airport & Railway Transfers" },
    private: { it: "Private Transfers", en: "Private Transfers" },
    business: { it: "Business & Events", en: "Business & Events" },
    hourly: { it: "Hourly Chauffeur Service", en: "Hourly Chauffeur Service" },
    scenic: { it: "Dolomitic Scenic Journeys", en: "Dolomitic Scenic Journeys" },
    night: { it: "Night & Dinner", en: "Night & Dinner" },
    unknown: { it: "Non lo so ancora", en: "Not sure yet" },
  },
  admin: {
    title: { it: "Pannello di controllo", en: "Control panel" },
  },
};
